export const ACCOUNT = 'account';
export const SIGNUP = 'signup';
export const SIGNIN = 'signin';
export const SIGNUP_VERIFICATION = 'verify-signup-otp';
export const SIGNUP_VERIFICATION_CONFIRMATION =
  'signup-verification-confirmation';
export const SIGNIN_VERIFICATION = 'verify-signin-otp';
export const CHANGE_PASSWORD = 'change-password';
export const CHANGE_PASSWORD_VERIFICATION_CONFIRMATION =
  'change-password-verification-confirmation';
export const FORGOT_PASSWORD = 'forgot-password';
export const RESET_PASSWORD = 'reset-password';
export const FORGOT_PASSWORD_NOTIFICATION = 'forgot-password-notification';
export const LOGOUT = 'logout';

export const DASHBOARD = 'dashboard';
// export const NOTIFICATIONS = 'notifications';
export const DRIVER_SETUP = 'driver-setup';
export const SINGLE_DRIVER_SETUP = `${DRIVER_SETUP}/single-driver-setup`;
export const LOOKUP = 'lookup';
export const TRIP_LOG = 'trip-log';
export const ADDRESS_BOOK = 'address-book';
export const DRIVER_LIST = 'driver-list';
export const HIRING_CONFLICTS = 'driver-list/hiring-conflicts';
export const VEHICLE_LIST = 'driver-list/vehicle-list';
export const DRIVER_PERFORMANCE = 'driver-performance';
export const DRIVER_PERFORMANCE_REPORT =
  'driver-list/driver-performance-report';
export const DRIVER_PERFORMANCE_EXIT_REPORT =
  'driver-list/driver-performance-exit-report';
export const DRIVER_LOOKUP_INFO = 'lookup/driver-lookup-info';
export const SETTINGS = 'settings';
export const PROFILE = `profile`;
export const ACCOUNT_AND_SECURITY = `account-and-security`;
export const ACCOUNT_MANAGEMENT = `account-management`;
export const API_KEYS = `api-keys`;
export const SETTINGS_PROFILE = `${SETTINGS}/${PROFILE}`;
export const SETTINGS_ACCOUNT_AND_SECURITY = `${SETTINGS}/${ACCOUNT_AND_SECURITY}`;
export const SETTINGS_ACCOUNT_MANAGEMENT = `${SETTINGS}/${ACCOUNT_MANAGEMENT}`;
export const SETTINGS_API_KEYS = `${SETTINGS}/${API_KEYS}`;

// NotFound
export const NOTFOUND = '404';
export const PAYMENT_SUCCESS = 'payment-successful';
export const THIRD_PARTY_API_ACTIVATION = 'partner/activate-key';
export const RATING = 'rating';
export const RATING_SUCCESS = 'rating-success';
